import apiClient from './client';

export interface DashboardStats {
  // Admin/Head Coach stats
  totalUsers?: number;
  totalPlayers?: number;
  totalCoaches?: number;
  totalSquads?: number;
  activeSquads?: number;
  totalSessions?: number;
  upcomingSessions?: number;
  totalCompetitions?: number;

  // Coach stats
  squads?: any[];

  // Player stats
  totalAttendance?: number;
  presentCount?: number;
  attendanceRate?: string;

  // Parent stats
  totalChildren?: number;
  children?: any[];
  childrenSquads?: any[];
}

export const dashboardAPI = {
  getDashboardStats: async () => {
    const response = await apiClient.get('/dashboard/stats');
    return response.data;
  },

  getUpcomingSessions: async (limit?: number) => {
    const response = await apiClient.get('/dashboard/upcoming-sessions', {
      params: { limit },
    });
    return response.data;
  },

  getRecentActivity: async (limit?: number) => {
    const response = await apiClient.get('/dashboard/recent-activity', {
      params: { limit },
    });
    return response.data;
  },
};
